import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { t } from '../utils/i18n';

// 로딩 오버레이
export function LoadingOverlay({ show, message }) {
  if (!show) return null;
  const displayMessage = message || t('ui.loading');
  
  return createPortal(
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(10, 10, 15, 0.9)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid var(--bg-tertiary)',
        borderTopColor: 'var(--accent-primary)',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <div style={{ marginTop: '16px', color: 'var(--text-secondary)' }}>
        {displayMessage}
      </div>
    </div>,
    document.body
  );
}

// 토스트 상태 관리
let toastTimeout = null;
let setToastState = null;

export function ToastContainer() {
  const [toast, setToast] = useState(null);
  
  useEffect(() => {
    setToastState = setToast;
    return () => { setToastState = null; };
  }, []);
  
  if (!toast) return null;
  
  const bgColor = {
    success: 'var(--accent-success)',
    error: 'var(--accent-danger)',
    warning: 'var(--accent-warning)',
    info: 'var(--accent-info)',
  }[toast.type] || 'var(--bg-tertiary)';
  
  return createPortal(
    <div style={{
      position: 'fixed',
      bottom: '80px',
      left: '50%',
      transform: 'translateX(-50%)',
      background: bgColor,
      color: 'white',
      padding: '12px 24px',
      borderRadius: '8px',
      zIndex: 9998,
      maxWidth: '90%',
      textAlign: 'center',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
      animation: 'fadeIn 0.2s ease',
    }}>
      {toast.message}
    </div>,
    document.body
  );
}

// 토스트 표시 함수
export function showToast(message, type = 'info', duration = 3000) {
  if (!setToastState) return;
  
  if (toastTimeout) {
    clearTimeout(toastTimeout);
  }
  
  setToastState({ message, type });
  
  toastTimeout = setTimeout(() => {
    setToastState(null);
  }, duration);
}
